import axios from 'axios';
import { User, Territory, GridInfo, ApiResponse } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://global-map-game.shijianzhongg.workers.dev/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authApi = {
  getGoogleAuthUrl: async () => {
    const response = await api.get<{ auth_url: string }>('/auth/google/url');
    return response.data.auth_url;
  },

  getGitHubAuthUrl: async () => {
    const response = await api.get<{ auth_url: string }>('/auth/github/url');
    return response.data.auth_url;
  },

  handleOAuthCallback: async (provider: 'google' | 'github', code: string) => {
    const response = await api.get<ApiResponse<{ user: User; token: string }>>(
      `/auth/${provider}/callback?code=${code}`
    );
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get<ApiResponse<User>>('/user/profile');
    return response.data;
  },
};

export const mapApi = {
  getGrid: async (lat: number, lng: number) => {
    const response = await api.get<ApiResponse<GridInfo>>(`/map/grid/${lat}/${lng}`);
    return response.data;
  },

  claimTerritory: async (lat: number, lng: number) => {
    const response = await api.post<ApiResponse<Territory>>('/map/claim', {
      lat,
      lng,
    });
    return response.data;
  },

  getTerritories: async (bounds?: {
    north: number;
    south: number;
    east: number;
    west: number;
  }) => {
    const params = new URLSearchParams();
    if (bounds) {
      params.append('north', bounds.north.toString());
      params.append('south', bounds.south.toString());
      params.append('east', bounds.east.toString());
      params.append('west', bounds.west.toString());
    }

    const response = await api.get<ApiResponse<Territory[]>>(`/map/territories?${params}`);
    return response.data;
  },
};

export const userApi = {
  createDoodle: async (iconData: string) => {
    const response = await api.post<ApiResponse<{ success: boolean; icon_url: string }>>('/user/doodle', {
      icon_data: iconData,
    });
    return response.data;
  },

  getProfile: async () => {
    const response = await api.get<ApiResponse<{
      id: string;
      username: string;
      doodle_points: number;
      territories_count: number;
      daily_login_streak: number;
      doodle_icon?: string;
      avatar_url?: string;
    }>>('/user/profile');
    return response.data;
  },

  claimDailyReward: async () => {
    const response = await api.post<ApiResponse<{
      reward_points: number;
      daily_login_streak: number;
      new_total_points: number;
    }>>('/user/daily-reward');
    return response.data;
  },
};